$(document).ready(function () {
	$(document).on('submit', '#form-one-click', function () {
		let $form = $(this),
			phone = $form.find('input[name=user_phone]').val().replace(/\D/g, '');

		$form.find('.error-phone').fadeOut().css('margin-top', 0);

		if (phone.length === 11) {
			return true;
		} else {
			$form.find('.error-phone').fadeIn().css('margin-top', 15);
			return false;
		}
	});
});